import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"

import "./footer.vue?vue&type=style&index=0&id=211fbf9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-211fbf9c"]])

export default __exports__